import { LoadingIndicator } from "../auth/AuthFormComponents";

const SubmitBtn = ({loading, disabled, handleSubmit,btnText}) => 
    <button 
        className={`green-button ${(loading || disabled) && 'green-button-disabled'}`}
        onClick={handleSubmit}
        disabled={disabled}
    >
        {loading && (<LoadingIndicator/>)}
            {btnText}
    </button>

export default SubmitBtn